import React from 'react';
import './BlogPost.css';

import logo from '../../images/band.jpg';

class BlogPost3 extends React.Component {
  render() {
    return (
    <div className="blogpost-outer">
      <div className="blogpost-title">
        <h3 className="blogpost-h3" >Grillevent im Alstätter Freibad!     -     09. Juni 2017</h3>
      </div>
      <div className="blogpost-content">
        <div className="blogpost-image">
          <img className="image-fit" alt="Grillevent im Alstätter Freibad" src={logo} />
        </div>
        <div className="blogpost-text">
          Wir spielen bald auf dem <a href="https://www.wn.de/Muensterland/Kreis-Borken/Alstaette/2850464-Die-junge-Band-Red-Lines-tritt-beim-Grillevent-im-Freibad-auf-Rote-Hosentraeger-als-Markenzeichen">Grillevent im Alstätter Freibad!</a> 
          <p>Vielen Dank an Anne Rensing und die DLRG Ortsgruppe Alstätte für den tollen Zeitungsartikel. Kommt doch vorbei und feiert mit uns! ;) </p>
          <p>Bis dahin eure Red Lines!</p>
        </div>

      </div>
    </div>
    )
  }
}

export default BlogPost3;


// WEBPACK FOOTER //
// ./src/components/blog/BlogPost3.js